import script from "./Alertes.vue?vue&type=script&setup=true&lang=js"
export * from "./Alertes.vue?vue&type=script&setup=true&lang=js"

import "./Alertes.vue?vue&type=style&index=0&id=169144d1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-169144d1"]])

export default __exports__